export const ALLOWED_UPLOAD_EXTENSIONS = [
  'jpg',
  'jpeg',
  'gif',
  'png',
  'pdf',
  'doc',
  'docx',
  'xls',
  'xlsx',
  'mp3',
  'mp4',
];

export const validateUploadFile = (file: File) => {
  const name = file.name.toLowerCase();
  if (ALLOWED_UPLOAD_EXTENSIONS.some((extension) => name.endsWith(`.${extension}`))) {
    return null;
  }
  return {
    code: 'file-invalid-type',
    message: `File extension not allowed`,
  };
};
